var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[_c('Sidebar'),_c('Navbar'),_c('v-main',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }